import ForumsScreen from './containers/forumsScreen'

export {default as ForumsScreenLayout} from './components/forumsScreenLayout'

export default ForumsScreen
